<template>
    <div class="container" id="MyInfo_container" v-title="'添加我的信息'">
        <Navigation-bar :title="scrollTop > titleHeight ? '添加我的信息' : ''" v-scrollShadow="scrollTop" @backPage="backPage()"></Navigation-bar>
         <div class="container_content">
             <div id="MyInfo" v-scroll="scrollTop">
                <Title title="添加我的信息" subtitle="填写个人基本信息"></Title>
                 <div class="MyInfo_content">
                    <Fold label="1.姓名" 
                        :text="form.name" 
                        :unfold="unfoldName == 'name'" 
                        :error="errorUnfold == 'name'"
                        :required="true"
                        @unfold-change="unfoldChange(...arguments,'name')" 
                    >
                        <Input v-model.trim="form.name" :focus="unfoldName == 'name'" :disabled="isRealName" placeholder="请输入姓名" ref="name" maxlength="20" v-if="isNew"></Input>
                        <Input :value="form.name" disabled v-else></Input>
                    </Fold>
                    <Fold label="2.手机号" 
                        :text="form.phone" 
                        :required="true"
                        @unfold-change="unfoldChange(...arguments,'phone')"
                    >
                        <Input :value="form.phone" disabled></Input>
                    </Fold>
                    <Fold label="3.证件类型" 
                        :text="cardInfo.name" 
                        :unfold="unfoldName == 'identityType'" 
                        :error="errorUnfold == 'identityType'"
                        :required="!!fieldsOptions.identity_limit"
                        @unfold-change="unfoldChange(...arguments,'identityType')"
                    >
                        <div>
                            <Option v-for="(item,index) in identityTypeList" :key="index"
                                :active="form.identityType == item.type" :disabled="isRealName"
                                @click="selectIdentityType(item.type)">{{item.name}}</Option>
                        </div>
                    </Fold>
                    <Fold label="4.证件号" 
                        :text="form.identityNo" 
                        :unfold="unfoldName == 'identityNo'" 
                        :error="errorUnfold == 'identityNo'"
                        :required="!!fieldsOptions.identity_limit"
                        @unfold-change="unfoldChange(...arguments,'identityNo')"
                    >
                        <Input v-model.trim="form.identityNo" :focus="unfoldName == 'identityNo'" :disabled="isRealName" placeholder="请输入证件号" :maxlength="cardInfo.len || 18" @input="identityNoChange"></Input>
                    </Fold>
                    <Fold label="5.性别" 
                        :text="['男','女'][form.sex - 1]" 
                        :unfold="unfoldName == 'sex'" 
                        :error="errorUnfold == 'sex'"
                        :required="!!fieldsOptions.sex_limit"
                        @unfold-change="unfoldChange(...arguments,'sex')" 
                    >
                        <template v-if="form.identityType == 1 && (!!fieldsOptions.identity_limit || !!form.identityNo) || isRealName">
                            <Option :active="form.sex == 1" disabled key="a1">男</Option>
                            <Option :active="form.sex == 2" disabled key="a2">女</Option>
                        </template>
                        <template v-else>
                            <Option :active="form.sex == 1" @click="sexChange(1)" key="b1">男</Option>
                            <Option :active="form.sex == 2" @click="sexChange(2)" key="b2">女</Option>
                        </template>
                    </Fold>
                    <Fold label="6.出生日期" 
                        :text="form.birthDate" 
                        :unfold="unfoldName == 'birthDate'" 
                        :error="errorUnfold == 'birthDate'"
                        :required="!!fieldsOptions.birthday_limit"
                        @unfold-change="unfoldChange(...arguments,'birthDate')"
                    >
                        <template v-if="form.identityType == 1 && (!!fieldsOptions.identity_limit || !!form.identityNo) || isRealName">
                            <Option disabled key="1">{{form.birthDate || "选择日期"}}</Option>
                        </template>
                        <template v-else>
                            <Option @click="setDate()" key="2">{{form.birthDate || "选择日期"}}</Option>
                        </template>
                    </Fold>
                    <Fold label="7.所属单位" 
                        :text="form.companyName || company.nameVal" 
                        :unfold="unfoldName == 'companyName'" 
                        @unfold-change="unfoldChange(...arguments,'companyName')" 
                    >
                        <Input v-model.trim="company.nameVal" :focus="unfoldName == 'companyName'" placeholder="请填写机构名称"></Input>
                        <div class="filtrate_content" v-show="company.loadMore || company.list.length > 0">
                            <div class="filtrate_list" >
                                <ul v-show="company.list.length > 0">
                                    <li v-for="(item,index) in company.list" :key="index" 
                                        @click="selectCompany(item.CompanyName, item.CompanyId)"
                                        v-html="highlight(item.CompanyName, company.nameVal)"
                                    ></li>
                                </ul>
                                <p class="load_more" v-show="company.loadMore">{{company.loadMore}}</p>
                            </div>
                        </div>
                    </Fold>
                    <Fold label="8.参赛人员组别" 
                        :text="groupText" 
                        :unfold="unfoldName == 'groupValue'" 
                        :error="errorUnfold == 'groupValue'"
                        :required="true"
                        @unfold-change="unfoldChange(...arguments,'groupValue')"
                        v-if="isNew"
                    >
                        <div>
                            <Option v-for="(item,index) in groups" :key="index"
                                disabledTrigger
                                checkbox
                                :active="getGroupActive(item)"
                                :disabled="getGroupDisabled(item) > 0"
                                @click="selectGroup(item)"
                            >{{item.GroupInfo.Name}}</Option>
                        </div>
                        <div class="explain_button" @click="explain.show = true">
                            <div>
                                <YD-image src="icon/icon_说明"></YD-image>
                                <span>组别说明</span>
                            </div>
                        </div>
                    </Fold>
                    <template v-if="ExtraDataDefines.length">
                        <template v-for="(item,index) in ExtraDataList">
                            <Fold :key="item.Field" :label="`${(isNew ? 8 : 7) + (index + 1)}.${item.Name}`" 
                                :text="extraForm[item.Field]" 
                                :unfold="unfoldName == item.Field" 
                                :error="errorUnfold == item.Field" 
                                :required="item.Mandatory"
                                @unfold-change="unfoldChange(...arguments,item.Field)" 
                            >
                                <template v-if="item.DataType == 'Text'">
                                    <Input :type="item.Precision ? 'textarea' : ''"
                                        :focus="unfoldName === item.Field" 
                                        v-model.trim="extraForm[item.Field]" 
                                        :placeholder="item.InputTips || `请输入${item.Name}`" 
                                        :maxlength="item.Max"
                                        @input="textInput"></Input>
                                </template>
                                <template v-else-if="item.DataType == 'Integer'">
                                    <Input type="number"
                                        integer
                                        :focus="unfoldName === item.Field" 
                                        v-model.number="extraForm[item.Field]"
                                        :placeholder="item.InputTips || `请输入${item.Name}`" 
                                        @input="textInput"></Input>
                                </template>
                                <template  v-else-if="item.DataType == 'Number'">
                                    <Input type="number"
                                        :focus="unfoldName === item.Field" 
                                        v-model.number="extraForm[item.Field]"
                                        :placeholder="item.InputTips || `请输入${item.Name}`" 
                                        @input="textInput"></Input>
                                </template>
                                <template v-else-if="item.DataType == 'Enum'">
                                    <div class="extra_select">
                                        <Option 
                                            :lineNumber="2"
                                            v-for="(option, optionIndex) in item.Values" 
                                            :key="optionIndex"
                                            :active="extraForm[item.Field] == option"
                                            @click="selectClick(item.Field, option)"
                                        >{{option}}</Option>
                                    </div>
                                </template>
                                <template v-else-if="['DateTime', 'Date'].includes(item.DataType)">
                                    <Input type="text"
                                        :value="extraForm[item.Field]"
                                        :placeholder="item.InputTips || `请选择${item.Name}`" 
                                        readonly="readonly" @click="selectDateTime(item)"></Input>
                                </template>
                            </Fold>
                        </template>
                    </template>
                    <div class="upload_images_title">
                        <div class="title">请上传{{cardInfo.name}}</div>
                        <div class="desc">{{cardInfo.text}}（非必填）</div>
                    </div>
                    <div class="upload_images identity_card">
                        <div class="image_item front" @click="uploadImg(1)">
                            <img src="@images/身份证_正面@2x.png" v-show="!form.frontImg" class="default">
                            <img :src="form.frontImg" v-show="form.frontImg" class="image">
                        </div>
                        <div class="image_item behind" @click="uploadImg(2)">
                            <img src="@images/身份证_反面@2x.png" v-show="!form.behindImg" class="default">
                            <img :src="form.behindImg" v-show="form.behindImg" class="image">
                        </div>
                    </div>
                    <div class="upload_images_title">
                        <div class="title">请上传免冠大头照</div>
                        <div class="desc">
                        <template v-if="fieldsOptions.portrait_photo">用于制作比赛秩序册（必填）</template>
                        <template v-else>非必填</template>
                        </div>
                    </div>
                    <div class="upload_images">
                        <div class="image_item portrait" @click="showUploadPortraitPhoto()">
                            <img src="@images/肖像@2x.png" v-show="!form.portraitImg" class="default">
                            <img :src="form.portraitImg" v-show="form.portraitImg" class="image">
                        </div>
                    </div>
                    <button id="submit" @click="submit()">完成</button>
                 </div>
             </div>
         </div>
         <div id="explain" v-show="explain.show">
            <div class="explain_content" style="height:65%">
                <div class="explain_title">组别说明</div>
                <div class="explain_text cover">
                    <ul>
                        <li v-for="(item,index) in explain.groupDesc" :key="index">
                            <p><span>{{item.GroupName}}：</span></p>
                            <template v-if="item.GroupDesc">
                                <p v-for="(descItem,descIndex) in item.GroupDesc.split('\n')" :key="descIndex">{{descItem}}</p>
                            </template>
                            <template v-else>
                                <p>无</p>
                            </template>
                        </li>
                    </ul>
                </div>
                <div class="operation">
                    <button v-pressed @click="explain.show = false">关闭</button>
                    <button v-pressed @click="explain.show = false">确认</button>
                </div>
            </div>
        </div>
        <Datetime-picker ref="datePicker" v-bind="datePickerConfig" @change="datePickerChange"></Datetime-picker>
        <UploadPortraitPhoto ref="uploadPortraitPhoto" :ossConfig="UploadOptions"></UploadPortraitPhoto>
    </div>
</template>
<script>
import Fold from '../components/Fold.vue';
import Input from '../components/Input.vue';
import Option from '../components/Option.vue';
import DatetimePicker from '@/components/datetime-picker/main.vue';
import UploadPortraitPhoto from '@/components/UploadPortraitPhoto.vue';

import { 
    convertSize,
    numberToChinese,
    dateFormat,
    identityCard,
    BV
} from '@js';
import {
    updatePortrait,
    backPage
} from '@js/appInteraction';
import {
    highlight
} from '@js/utils/text';
import {
    GetLeagueEnrollGroupDesc,
    GetLeagueEnrollFieldsOptions,
    GetCompanyPageList,
    CheckMeCanIndividualEnroll,
    GetIndividualEnrollUploadOption,
    GetAllowMeIndividualEnrollGroup,
    SaveMeIndividualEnroll,
    GetMyIndividualEnrollPersonalInfo,
    AlterMyIndividualEnrollPersonalInfo,
    CheckIndividualEnrollChangedGroupsAfterBaseInfoChanged,
    GetUserRegisInfo
} from '@/api';
import extra from '@/mixins/extra';
import formValidator from '@/common/formValidator';
export default {
    name:"MyInfo",
    components:{
        Fold,
        Input,
        Option,
        DatetimePicker,
        UploadPortraitPhoto
    },
    mixins: [extra],
    data(){
        return {
            subLeagueId: 0,
            isNew: 0,
            scrollTop:0,
            unfoldName: '',
            errorUnfold: '',
            isDataUpdate: false,
            userId: 0,
            userEnrollId: 0,
            isRealName: false,
            form:{
                name:"",
                phone:"",
                identityType: 1,
                identityNo:"",
                sex:0,
                birthDate:"",
                companyName: "",
                companyId: 0,
                groupValue:[],
                frontImg:"",
                behindImg:"",
                portraitImg:""
            },
			fieldsOptions: {},
            enrollOptions: {},
            company:{
                nameVal:"",
                list:[],
                loadMore:""
            },
            groups:[],
            explain:{
                type:2,
                show:false,
                groupDesc:[]
            },
            UploadOptions:{},
            datePickerConfig: {}
        }
    },
    created(){
        this.subLeagueId = +this.$route.query.subLeagueId || 0;
        this.isNew = +this.$route.query.new || 0;
        this.init();
        GetLeagueEnrollFieldsOptions({
            SubLeagueId: this.subLeagueId
        }).then(data=>{
            if(data.Code == 0){
                this.fieldsOptions = data.FieldsOptions;
                this.initExtraForm(data.ExtraDataDefines);
                this.enrollOptions = data.EnrollOptions;
            }
        })
        GetLeagueEnrollGroupDesc({
            SubLeagueId: this.subLeagueId
        }).then(data=>{
            if(data.Code == 0){
                this.explain.groupDesc = data.GroupDescList;
            }
        })
        GetIndividualEnrollUploadOption().then(data=>{
            if(data.Code == 0){
                this.UploadOptions = data.Options;
            }
        })
        backPage(()=>{
            this.backPage();
        })
    },
    computed:{
        titleHeight(){
            return convertSize(1.08);
        },
        identityTypeList(){
            return [
                {
                    name: '身份证（港澳台居住证）',
                    text:"二代身份证（港澳台居住证）正反面照片",
                    type: 1,
                    len: 18
                },
                // {
                //     name:'护照',
                //     text:"个人信息页",
                //     type:2,
                //     len: 9,
                //     RegEx:/^[a-zA-Z0-9]{9}$/
                // },
                // {
                //     name:'台湾居民来往大陆通行证',
                //     text:"个人信息页",
                //     type:4,
                //     len: 8,
                //     RegEx:/^\d{8}$/
                // },
                // {
                //     name:'港澳居民来往内地通行证',
                //     text:"个人信息页",
                //     type:5,
                //     len: 9,
                //     RegEx:/^(H|M)\d{8}$/
                // }
            ]
        },
        groupText(){
            let length = this.form.groupValue.length;
            if(length > 0){
                return '已选择' + numberToChinese(length).replace('二','两') + '项'
            }
            return '';
        },
        cardInfo(){
            return this.identityTypeList.find(item=>item.type == this.form.identityType) || {};
        },
		rules(){
			return {
				name: (value, callback)=>{
					if(!value){
						callback('请输入姓名');
					}else if(value.length < 2){
						callback('姓名最少两个字符');
					}
					callback();
				},
				identityType: (value, callback)=>{
					if(!value && this.fieldsOptions.identity_limit){
						callback('请选择证件类型');
					}
					callback();
				},
				identityNo: (value, callback)=>{
					if(!value){
						if(this.fieldsOptions.identity_limit){
							callback('请输入证件号');
						}
					}else if(this.form.identityType == 1){
						let info = identityCard(value);
						if(!info){
							callback('证件号格式有误');
						}else{
							let y = new Date(info.dateBirth).getFullYear();
							if(y < 1900 || y > new Date().getFullYear()){
								callback(y < 1900 ? '证件号年份不能小于1900' : '证件号出生年份不能大于当前年份');
							}
						}
					}else if(this.form.identityType != 1 && (value.length != this.cardInfo.len || !value.match(this.cardInfo.RegEx))){
						callback('证件号格式有误');
					}
					callback();
				},
				sex: (value, callback)=>{
					if(!value && this.fieldsOptions.sex_limit){
						callback('请选择性别');
					}
					callback();
				},
				birthDate: (value, callback)=>{
					if(!value && this.fieldsOptions.birthday_limit){
						callback('请选择出生日期');
					}
					callback();
				},
				groupValue: (value, callback)=>{
					if(this.isNew && value.length == 0){
						callback('至少要选择一个可报名的组别');
					}
					callback();
				},
				portraitImg: (value, callback)=>{
					if(!value && this.fieldsOptions.portrait_photo){
						callback('请上传照片');
					}
					callback();
				}
			}
		}
    },
    watch:{
		'form.sex'(){
            this.setDataUpdate();
			if(!this.isNew) return;
			this.getGroupList();
		},
		'form.birthDate'(){
			if(this.form.identityType != 1 || !this.form.identityNo){
				this.setDataUpdate();
				if(!this.isNew) return;
				this.getGroupList();
			}
		}
    },
    methods:{
        highlight,
        backPage(){
            if(!this.isDataUpdate){
                this.$navigation.back();
                return;
            }
            this.dataVerify().then(()=>{
                this.$Prompt({
                    title: '温馨提示',
                    message: '您的信息已填写完成，返回将不保留当前填写',
                    showCancel: true,
                    cancelText: '继续返回',
                    confirmText: '提交',
                    showClose: true
                }).then(confirm=>{
                    if(confirm){
                        this.submit();
                    }else{
                        this.$navigation.back();
                    }
                })
            }).catch(()=>{
                this.$Prompt({
                    title: '温馨提示',
                    message: '返回将不保留当前填写，请确认操作',
                    showCancel: true,
                    cancelText: '确认',
                    confirmText: '取消',
                    showClose: true
                }).then(confirm=>{
                    if(!confirm){
                        this.$navigation.back();
                    }
                })
            })
        },
        unfoldChange(e, unfold, unfoldName){
            if(!unfold){
                this.unfoldName = '';
            }else{
                this.unfoldName = unfoldName;
                this.$nextTick(function(){
                    if(!BV().ios){
                        var subItemTop = e.offsetTop;
                        this.scrollTop = subItemTop - 10;
                    }
                })
            }
        },
		setDataUpdate(){
			this.isDataUpdate = true;
		},
		//通用 Text
		textInput(){
			this.setDataUpdate();
		},
		//通用 Enum
		selectClick(formKey, value){
			let oldVal = this.extraForm[formKey];
			if(value != oldVal){
				this.extraForm[formKey] = value;
				this.setDataUpdate();
			}
		},
		//通用 Date
		selectDateTime(item){
			let {
				Field,
				Min,
				Max,
                DataType
			} = item;
            let { 
                format,
                datePickerType
            } = this.getDateFormat(DataType);
			let date = dateFormat(this.extraForm[Field] || new Date(), format);
			let config = {
                type: datePickerType,
				value: date,
				min: dateFormat(Min || '1970-1-1 00:00:00', format),
				max: dateFormat(Max || '2099-12-31 23:59:59', format),
				formKey: Field,
                DataType
			}
            this.datePickerConfig = config;
            this.$refs.datePicker.show();
		},
		//通用 Date
		datePickerChange(value){
			let formKey = this.datePickerConfig.formKey;
			if(!formKey) return;
            if(formKey == 'birthDate'){
                this.$set(this.form, 'birthDate', dateFormat(new Date(value),'yyyy-MM-dd'));
                this.setDataUpdate();
            }else{
                let { format } = this.getDateFormat(this.datePickerConfig.DataType);
                value = dateFormat(value, format);
                let oldVal = this.extraForm[formKey];
                if(value != oldVal){
                    this.extraForm[formKey] = value;
                    this.setDataUpdate();
                }
            }
		},
        init(){
			this.getGroupList();
            if(this.isNew){
                CheckMeCanIndividualEnroll({
                    LeagueId: this.subLeagueId
                }).then(data=>{
                    if(data.Code == 0){
                        if(!data.CanEnroll){
                            this.$Toast.error('不能参加个人报名');
                            setTimeout(() => {
                                this.$navigation.back();
                            }, 2000);
                        }else{
                            let userInfo = data.UserInfo;
                            let {
                                UserId,
                                UserEnrollId,
                                Name,
                                Phone,
                                CompanyId,
                                CompanyName,
                                HasIdentitySuccess
                            } = userInfo;
                            this.userId = UserId;
                            this.userEnrollId = UserEnrollId;
                            let form = {
                                name: Name || '',
                                phone: Phone || '',
                                companyName: CompanyName || '',
                                companyId: CompanyId || 0,
                                groupValue: [],
                            }
                            this.$set(this, 'form', form);
                            this.company.nameVal = CompanyName || '';
                            this.isRealName = HasIdentitySuccess;
							this.setUserInfo(userInfo);
                            this.$nextTick(function(){
                                this.isDataUpdate = false;
                            })
                        }
                    }
                })
            }else{
                GetMyIndividualEnrollPersonalInfo({
                    LeagueId: this.subLeagueId
                }).then(data=>{
                    if(data.Code == 0){
                        let userInfo = data.UserInfo;
                        let {
                            UserId,
                            UserEnrollId,
                            Name,
                            Phone,
                            CompanyId,
                            CompanyName,
                        } = userInfo;
                        this.userId = UserId;
                        this.userEnrollId = UserEnrollId;
                        let form = {
                            name: Name || '',
                            phone: Phone || '',
                            companyName: CompanyName || '',
                            companyId: CompanyId || 0,
                            groupValue: [],
                        }
                        this.$set(this, 'form', form);
                        this.company.nameVal = CompanyName || '';
						this.initExtraForm(undefined, userInfo.Extras);
                        this.$nextTick(function(){
                            this.isDataUpdate = false;
                        })
						this.getUserRegisInfo(userInfo);
                    }else{
                        this.$Prompt({
                            title: '温馨提示',
                            message: data.Message,
                            confirmText: '知道了'
                        }).then(confirm=>{
                            if(confirm){
                                this.$navigation.back();
                            }
                        })
                    }
                })
            }
        },
        /**
		 * 设置信息到页面
		 */
        setUserInfo(userInfo){
            if(!userInfo) return;
            let form = this.form;
            form.phone = userInfo.Phone;
            form.identityType = userInfo.IdentityType || 1;
            form.identityNo = userInfo.IdentityNo || "";
            form.frontImg = userInfo.IdentityPhoto1 || "";
            form.behindImg = userInfo.IdentityPhoto2 || "";
            form.portraitImg = userInfo.PortraitPhoto || "";
            if(userInfo.IdentityType == 1 && userInfo.IdentityNo){
                let info = identityCard(userInfo.IdentityNo);
                if(info){
                    form.sex = info.sex;
                    form.birthDate = dateFormat(new Date(info.dateBirth),'yyyy-MM-dd');
                }
            }else{
                form.sex = userInfo.Gender || 0;
                form.birthDate = userInfo.Birthday ? dateFormat(new Date(userInfo.Birthday),'yyyy-MM-dd') : "";
            }
            
			this.$set(this, 'form', {...form});
        },
        /**
         * 获取用户注册信息
         */
        getUserRegisInfo(userInfo){
			let {
				IdentityPhoto1, 
				IdentityPhoto2, 
				PortraitPhoto
			} = userInfo;
			GetUserRegisInfo({
				QueryUserId: this.userId
			}).then(data => {
				if(data.Code == 0){
					let regisInfo = data.RegisInfo;
			        this.isRealName = regisInfo.HasIdentitySuccess;
                    if(this.isRealName){
                        this.setUserInfo({
                            ...regisInfo,
                            IdentityPhoto1,
                            IdentityPhoto2,
                            PortraitPhoto
                        });
                    }else{
                        userInfo.Phone = regisInfo.Phone; //手机号可能已经更新
                        this.setUserInfo(userInfo);
                    }
                    this.$nextTick(function(){
                        this.isDataUpdate = false;
                    })
				}
			})
        },
        selectIdentityType(type){
            let identityType = this.form.identityType;
            if(identityType != type){
				this.form.identityType = type;
				this.form.identityNo = '';
				this.unfoldName = 'identityNo';
            }
        },
        identityNoChange(){
			let {
				identityType,
				identityNo
			} = this.form;
			if(identityType == 1 && identityNo.length == 18){
				let info = identityCard(identityNo);
				if (!info) {
                    this.$Toast.error('证件号格式有误');
					this.errorUnfold = 'identityNo';
				}else{
					let y = new Date(info.dateBirth).getFullYear();
					if(y < 1900 || y > new Date().getFullYear()){
                        this.$Toast.error(y < 1900 ? '证件号年份不能小于1900' : '证件号出生年份不能大于当前年份');
						this.errorUnfold = 'identityNo';
					}else{
						this.form.sex = info.sex;
						this.form.birthDate = dateFormat(new Date(info.dateBirth),'yyyy-MM-dd');
					}
				}
			}else if(identityType == 1 && identityNo.length != 18){
				this.form.sex = 0;
				this.form.birthDate = "";
			}
			this.setDataUpdate();
		},
		sexChange(sex){
			if(this.form.sex != sex){
				this.form.sex = sex;
			}
		},
        setDate(){//出生日期
			let config = {
                type: 'date',
				value: dateFormat(this.form.birthDate, 'yyyy-MM-dd'),
				min: "1900-01-01",
				max: dateFormat(new Date(),'yyyy-MM-dd'),
				formKey: 'birthDate'
			}
            this.datePickerConfig = config;
            this.$refs.datePicker.show();
        },
        getCompanyList(name){
            this.form.companyId = 0;
            this.form.companyName = "";
            this.company.list = [];
            this.company.loadMore = '正在查询···';
            GetCompanyPageList({
                Continuation: {
                    LastId: 0,
                    MaxCount: 20
                },
                CompanyName: name,
                AuditStatus: null
            }).then(data=>{
                if(name == this.company.nameVal){
                    this.company.loadMore = '';
                    if(data.Code == 0){
                        this.company.list = data.ContinueList || [];
                    }
                }
            }).catch(()=>{
                this.company.loadMore = '';
            })
        },
        selectCompany(name,id){
            this.form.companyId = id;
            this.form.companyName = name;
            this.company.nameVal = name;
            this.setDataUpdate();
        },
        getGroupList(){
            GetAllowMeIndividualEnrollGroup({
                LeagueId: this.subLeagueId,
                Gender: this.form.sex || null,
                Birthday: this.form.birthDate || null,
            }).then(data=>{
                if(data.Code == 0){
                    let groups = data.AllowGroup || [];
					let groupValue = groups.filter(item=>{
                        let errorCode = this.getGroupDisabled(item);
                        if(item.AgentEnroll && errorCode == 90){
                            return true;
                        }else if(this.getGroupActive(item) && errorCode == 0){
                            return true;
                        }
                        return false;
                    }).map(item=>item.GroupInfo.Id);
                    this.groups = groups;
                    this.$set(this.form, 'groupValue', groupValue);
                }
            })
        },
        selectGroup(obj){
            let errorCode = this.getGroupDisabled(obj);
            let groupValue = [...this.form.groupValue];
            if(this.getGroupActive(obj) && errorCode != 90){//队友代报名，请联系队友删除
                let index = groupValue.indexOf(obj.GroupInfo.Id);
                groupValue.splice(index, 1);
            }else{
                if(errorCode > 0){
                    let {
                        athlete_enroll_single_or_doublegroup_num_max
                    } = this.enrollOptions;
                    let message;
                    switch(errorCode){
                        case 3:
                            message = '不符合该组别参赛要求';
                            break;
                        case 8:
                            message = `最多只能同时报名${athlete_enroll_single_or_doublegroup_num_max}个组别`;
                            break;
						case 10:
							message = '该组别已报满';
							break;
                        case 90:
                            message = '队友代报名，请联系队友删除';
                            break;
                        case 99:
                            message = '你在该组别中被举报，不能报名';
                            break;
                    }
                    this.$Toast.warning(message);
                    return;
                }
                groupValue.push(obj.GroupInfo.Id);
            }
            this.setDataUpdate();
            this.$set(this.form,'groupValue',groupValue);
        },
        getGroupActive(obj){
            return this.form.groupValue.includes(obj.GroupInfo.Id);
        },
		getGroupDisabled(obj){
            if(!obj.AllowEnroll) return 3;//不符合参赛要求
            if(obj.IsImpeached) return 99;//被举报
            if(obj.AgentEnroll) return 90;//队友代报名
			let isInclude = this.getGroupActive(obj);
			if(!isInclude) { //涉及到多个组别之间交叉关系的判断，只能针对没有被勾中的组别。
                let {
                    athlete_enroll_single_or_doublegroup_num_max
                } = this.enrollOptions;
                if(athlete_enroll_single_or_doublegroup_num_max > 0){
                    let filter = this.groups.filter(item=>[1, 3].includes(item.GroupInfo.GroupType) && this.getGroupActive(item));
                    if(filter.length >= athlete_enroll_single_or_doublegroup_num_max){
                        return 8;//个人/双打组数量超出
                    }
                }
            }
			// let EnrollQuotaStore = obj.EnrollQuotaStore || {};
			// if(EnrollQuotaStore.TotalNum > 0 && EnrollQuotaStore.LeftNum == 0){
			// 	return 10;//组别已报满，所有报名的代表队、个人
			// }
			return 0;
        },
        uploadImg(type){
            updatePortrait({...this.UploadOptions,Menu:0,Resolutions:'1024,768'}).then(data=>{
                if(type == 1){
                    this.form.frontImg = data.Url;
                }else if(type == 2){
                    this.form.behindImg = data.Url;
                }
                this.setDataUpdate();
            })
        },
		showUploadPortraitPhoto(){
			this.$refs.uploadPortraitPhoto.choose().then(ossUrl=>{
				this.form.portraitImg = ossUrl;
				this.setDataUpdate();
			})
		},
        dataVerify(isSubmit){
            let props = Object.keys(this.rules);
			let form = this.form;
			return new Promise((resolve, reject)=>{
				new formValidator(form, props, this.rules).validate((valid, message, prop)=>{
					if(valid){
						let error = this.verifyExtraForm();
						if(error){
							valid = false;
							message = error.text;
							prop = error.id;
						}
					}
					if(isSubmit){
						if(!valid){
                            this.$Toast.error(message);
							this.unfoldName = prop;
							this.errorUnfold = prop;
							return;
						}
                        let Extras = this.getExtraForm();
						let params = this.isNew ? {
							"LeagueId": this.subLeagueId,
							"UserInfo": {
								"UserId": this.userId,
								"Name": form.name,
								"Phone": form.phone,
								"Gender": form.sex || null,
								"Birthday": form.birthDate || null,
								"IdentityType": form.identityType || null,
								"IdentityNo": form.identityNo || null,
								"IdentityPhoto1": form.frontImg,
								"IdentityPhoto2": form.behindImg,
								"PortraitPhoto": form.portraitImg,
								"CompanyId": form.companyId,
								"CompanyName": form.companyName || this.company.nameVal,
								"Extras": Extras
							},
							"GroupIds": form.groupValue
						} : {
							"LeagueId": this.subLeagueId,
							"EnrollBaseInfo": {
								"UserId": this.userId,
								"Name": form.name,
								"Phone": form.phone,
								"Gender": form.sex || null,
								"Birthday": form.birthDate || null,
								"IdentityType": form.identityType || null,
								"IdentityNo": form.identityNo || null,
								"IdentityPhoto1": form.frontImg,
								"IdentityPhoto2": form.behindImg,
								"PortraitPhoto": form.portraitImg
							},
							"CompanyId": form.companyId,
							"CompanyName": form.companyName || this.company.nameVal,
							"Extras": Extras
						};
						resolve(params);
					}else{
						valid ? resolve() : reject();
					}
                })
            })
        },
        submit(){
            this.dataVerify(true).then(params=>{
                if(this.isNew){
                    SaveMeIndividualEnroll(params).then(data=>{
                        if(data.Code == 0){
                            this.$Toast.success('保存成功');
                            this.$navigation.replace(`/Enroll/OneselfEnroll/AuditDetail?subLeagueId=${this.subLeagueId}&audit=1`);
                        }
                    })
                }else{
                    CheckIndividualEnrollChangedGroupsAfterBaseInfoChanged({
						"LeagueId": params.LeagueId,
						"UserEnrollId": this.userEnrollId,
						"EnrollBaseInfo": params.EnrollBaseInfo
					}).then(data=>{
						if(data.Code == 0){
							let cancelGroups = data.CancelGroups || [],
								removeGroups = data.RemoveMateGroups || [];
							if(cancelGroups.length || removeGroups.length){
								let cancelText = cancelGroups.length ? `将取消【${cancelGroups.map(item=>item.Name).join('、')}】的报名，` : '',
									removeText = removeGroups.length ? `将移除【${removeGroups.map(item=>item.Name).join('、')}】的队友，` : '';
                                this.$Prompt({
                                    title: '报名信息不符合组别限制',
                                    message: `${cancelText}${removeText}是否继续？`,
                                    showCancel: true,
                                    cancelText: '取消',
                                    confirmText: '确认',
                                    showClose: true
                                }).then(confirm=>{
                                    if(confirm){
                                        this.alter(params);
                                    }
                                })
                            }else{
                                this.alter(params);
                            }
                        }
                    })
                }
            })
        },
        alter(params){
            AlterMyIndividualEnrollPersonalInfo(params).then(data=>{
                if(data.Code == 0){
                    this.$Toast.success('保存成功');
                    this.$store.commit('monitor/ONESELF_ENROLL_MY_INFO');
                    setTimeout(()=>{
                        this.$navigation.back();
                    },1000)
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
#MyInfo{
    position: relative;
    .MyInfo_content{
        padding: 0 40px;
        box-sizing: border-box;
    }
    .filtrate_content{
        width: 100%;
        height: auto;
        padding-top: 40px;
        box-sizing: border-box;
        .filtrate_list{
            max-height: 308px;
            overflow-y: auto;
            margin-bottom: 40px;
            ul li{
                min-height: 40px;
                font-size: 28px;
                color: #8B8C8D;
                line-height: 40px;
                font-weight: 400;
                padding: 0 32px;
                box-sizing: border-box;
                margin-bottom: 32px;
                &:last-of-type{
                    margin-bottom: 0;
                }
            }
        }
        .noData{
            height: 84px;
            font-size: 28px;
            color: #8B8C8D;
            font-weight: 400;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 40px;
        }
    }
    
    .extra_select > div{
        display: inline-block;
        width: calc((100% - 18px) / 2);
        margin-right: 18px;
        &:nth-of-type(2n){
            margin-right: 0;
        }
    }
    .upload_title{
        margin-top: 56px;
        p:nth-of-type(1){
            font-size: 32px;
            color: #1B1C1E;
            font-weight: 500;
            line-height: 44px;
            margin-bottom: 8px;
        }
        p:nth-of-type(2){
            font-size: 24px;
            color: #7E7E7F;
            font-weight: 400;
            line-height: 34px;
            margin-bottom: 24px;
        }
    }
    
    @include uploadImage;
    .upload_images{
        display: flex;
        .front,
        .behind{
            width: 261px;
            height: 196px;
            --center-size: 82px;
            --corner-size: 60px;
            .default{
                --width: 190px;
                --height: 116px;
            }
        }
        .front{
            margin-right: 56px;
        }
        .portrait{
            width: 240px;
            min-height: 240px;
            --center-size: 82px;
            --corner-size: 60px;
            .default{
                --width: 120px;
                --height: 160px;
            }
            .image{
                height: auto;
            }
        }
    }
    .explain_button{
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
        color: #2F343C;
        font-weight: 400;
        margin-top: 20px;
        div{
            display: flex;
            align-items: center;
        }
        img{
            height: 48px;
            width: 48px;
        }
    }
}
#submit{
    @include submit-button;
}
#explain{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    background: rgba(0,0,0,0.40);
    display: flex;
    align-items: center;
    justify-content: center;
    .explain_content{
        width: 670px;
        background: #FFFFFF;
        box-shadow: 0px 36px 64px -8px rgba(136,136,136,0.25);
        border-radius: 20px;
        overflow: hidden;
        .explain_title{
            height: 164px;
            font-size: 36px;
            color: #3A3F49;
            font-weight: 500;
            line-height: 154px;
            padding: 0 54px;
            padding-top: 10px;
            box-sizing: border-box;
        }
        .explain_text{
            height: calc(100% - 275px);
            padding: 0 54px;
            box-sizing: border-box;
            margin-bottom: 20px;
            position: relative;
            &.cover::after{
                content: "";
                width: 100%;
                height: 152px;
                background-image: linear-gradient(180deg, rgba(255,255,255,0.00) 42%, #FFFFFF 65%);
                position: absolute;
                left: 0;
                bottom: -40px;
            }
            ul{
                height: 100%;
                overflow-y: auto;
                li{
                    span{
                        color: #7AD21A;
                        font-weight: 500;
                    }
                    font-size: 28px;
                    color: #3A3F49;
                    line-height: 44px;
                    font-weight: 400;
                    margin-bottom: 32px;
                }
            }
        }
        .operation{
            width: 100%;
            border-top: 1px solid #EFEFEF;
            display: flex;
            position: relative;
            button{
                flex: 1;
                @include line-height(90px);
                font-size: 28px;
                color: #3A3F49;
                text-align: center;
                font-weight: 500;
                border-right: 1px solid #EFEFEF;
                box-sizing: border-box;
                &.pressed{
                    background: rgba(0,0,0,0.05);
                }
                &:last-of-type{
                    color: #7AD21A;
                    border-right: none;
                }
            }
        }
    }
}
</style>
<style lang="scss">
#MyInfo_container{
    #date_container{
        height: 100%;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 20;
        background: rgba(0,0,0,0.40);
        .date_container_content{
            width: auto;
            height: auto;
            background: #FFFFFF;
            box-shadow: 0px 36px 64px -8px rgba(136,136,136,0.25);
            border-radius: 20px;
            overflow: hidden;
            margin-top: 10%;
        }
        .date_content{
            width: auto;
            height: auto;
            font-size: 28px;
            .layui-laydate{
                width: auto;
                height: auto;
                font-size: 28px;
                color: #1B1C1E;
                font-weight: 400;
                box-shadow: none;
                border: none;
                .layui-laydate-main {
                    width: auto;
                }
            }
            .layui-laydate-header{
                width: 100%;
                height: 100px;
                font-size: 32px;
                color: #7AD21A;
                line-height: 48px;
                font-weight: 700;
                display: flex;
                align-items: center;
                padding: 15px 30px 5px;
                .laydate-set-ym{
                    padding: 0 15px;
                }
                i{
                    position: static;
                    font-size: 32px;
                    padding: 0 15px;
                    color: #7AD21A;
                }
                i:hover,
                span:hover{
                    color: inherit;
                }
            }
            .layui-laydate-content{
                padding: 15px 30px;
                td,th{
                    width: 80px;
                    height: 70px;
                    border-radius: 8px;
                }
                td.layui-this{
                    color: #FFFFFF;
                    font-weight: 700;
                    background: #7AD21A !important;
                }
            }
            .layui-laydate-list{
                padding: 25px 30px;
                li{
                    width: 33%;
                    @include line-height(85px);
                    border-radius: 8px;
                    &.layui-this {
                        background: #7AD21A !important;
                    }
                }
            }
            .laydate-month-list>li{
                @include line-height(90px);
                margin: 0.15rem 0 !important;
            }
        }
        .operation{
            height:90px;
            width: 100%;
            display: flex;
            border-top: 1px #EFEFEF solid;
            button{
                flex: 1;
                @include line-height(90px);
                font-size: 28px;
                color: #3A3F49;
                text-align: center;
                font-weight: 500;
                border-right: 1px #EFEFEF solid;
                &:last-of-type{
                    color: #7AD21A;
                    border-right: none;
                }
            }
        }
    }
}
</style>